import { render, staticRenderFns } from "./SeoBox.vue?vue&type=template&id=4119feda&scoped=true"
import script from "./SeoBox.vue?vue&type=script&lang=js"
export * from "./SeoBox.vue?vue&type=script&lang=js"
import style0 from "./SeoBox.vue?vue&type=style&index=0&id=4119feda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4119feda",
  null
  
)

export default component.exports